import React, { useState } from 'react';
import { MapContainer, Marker , TileLayer,Popup } from "react-leaflet";
import { Icon } from "leaflet";
import * as myData from "../data/myloc.json"

export const icon = new Icon({
  iconUrl: "/maps.svg",
  iconSize: [25, 25]
});

function ContactsPage() {
        
        return (
          <div className="container-fluid contact-cont" id="contact"  style={{backgroundColor: "#f7f7f7",fontFamily: 'Roboto',fontWeight: '400'}}>
             <div className="PageIntroBanner_header"><div className="row p-lg-5" style={{marginRight:"15px",backgroundColor:"#f7f7f7"}}>
              <div className="col-lg-10 mx-auto text-center"><h3 style={{color:"#002856"}}>Contact Us</h3>
              <h2 className="contact mx-auto" style={{fontFamily: 'Roboto',fontWeight: '400',color : "#002856",fontSize: "x-large"}}>Cell : +91 9048283666  •  Email : aashvillas@gmail.com </h2>
              </div></div>
          
            
            </div>
         <div className="col-10  mx-auto">
          <MapContainer center={[ 10.392094,  76.155462]} zoom={16} style={{ height: "70vh" }} >
          <TileLayer
            attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
    
          {myData.features.map(park => (
            <Marker
              key={park.properties.PARK_ID}
              position={[
                park.geometry.coordinates[1],
                park.geometry.coordinates[0]
              ]}
              icon={icon}
            >
            </Marker>

          ))}
          </MapContainer>

          </div>
          <div className="contact-foot"></div>
          </div>
        );
    }
      

export default ContactsPage;
